import React from 'react';
import '../../App.css';
import '../Css/Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';


function Footer(){
    const title = {
        fontFamily: 'Sarabun',
        fontSize: '1.1em',
        color: '#ebeae5',
        padding: '2%'
    }
    const dev = {
        width: '100%',
        height: '10vh',
        backgroundColor: '#1e1818',
        color: '#efeeea',
        fontFamily: 'SarabunRegular',
        fontSize: '1em',
        display: 'flex',
        textAlign: 'center',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center'
    }
    const Name = {
        color: '#efeeea',
        textDecoration: 'none',
        margin: '0% 3px'
    }

    const handleButtonHover = (event) => {
        event.target.style.color = '#ffd600';
      };
      const handleButtonLeave = (event) => {
        event.target.style.color = '#efeeea';
      };

return(
    <> 
    <div className='footer'>
        <div className='left'>
            <h2>Contact</h2>
            <a href="mailto:info@niebla.ar">info@niebla.ar</a>
            <p>Buenos Aires, Argentina.</p>
        </div>
        <div className='middle'>
            <Link to='https://www.facebook.com/nieblafilmsok' target='_blank'><FontAwesomeIcon icon={faFacebook} className='icon'/></Link>
            <Link to='https://www.instagram.com/niebla.films/' target='_blank'><FontAwesomeIcon icon={faInstagram} className='icon'/></Link>
            <Link to='https://www.youtube.com/@niebla_films' target='_blank'><FontAwesomeIcon icon={faYoutube} className='icon'/></Link>
        </div>
        <div className='right'>
            <h1 style={title}>Festival</h1>
            <Link to='https://docs.google.com/forms/d/e/1FAIpQLSd46mOg7FD-Ph4OGpS4OVcGrb38WBDec81aAwGEdNxIuAPmeQ/viewform' target='_blank'><button type="button" class="btn btn-outline-danger" id="enlaceFormulario">Inscríbete</button></Link>
        </div>
    </div>
    <div style={dev}>
        <h3 style={dev}>Desarrollado por <Link to='https://www.yunus.com.ar' target='_blank' style={Name}
        onMouseEnter={handleButtonHover}
        onMouseLeave={handleButtonLeave}
        >Yunus</Link></h3>
    </div>
    </>
    )
}  

export default Footer;